import { modalOpen } from "./modal";
import Dom from "../utility/dom";
import { setCookie, getCookie } from "../utility/utils";

const hasModalBeenOpened = getCookie("newsletterModalOpened");
// TODO: check if user has submitted form to subscribe and set new Cookie
const hasSubscribed = getCookie("newsletterSubscribed");

/**
 * Opens the specified modal, sets a cookie for the specified modal and removes eventListeners.
 *
 * @param {Element} modal - The modal element.
 * @param {string} cookieKey - The key to store in the cookie.
 * @param {string|boolean} [cookieValue] - (Optional) The value to store in the cookie. The Default is "true"
 * @returns {(function(): void)|*} returns a cleanup function to remove the event listeners
 */
const setModal = (modal, cookieKey, cookieValue = true) => {
  modalOpen(null, modal);
  setCookie(cookieKey, cookieValue, 7);
  /**
   * Cleans up the element by removing the event listener.
   */
  function cleanupEvents() {
    window.removeEventListener("scroll", handleScroll);
    Dom.body.removeEventListener("mouseleave", handleMouseLeave);
  }
  cleanupEvents();
};

/**
 * Sets up Newsletter Modal.
 *
 * @param {Event} e - The event.
 * @param {number} ms - The number of milliseconds for the timeout.
 */
export const initNewsLetterModal = (e, ms = 7000) => {
  if (hasSubscribed) return;
  if (hasModalBeenOpened) return;
  const modal = document.querySelector("#newsletter_modal");
  const form = modal ? modal.querySelector("form") : null;

  // TODO: check on staging or find a new solution for form success cookie
  if (form) {
    form.addEventListener("submit", () => {
      const success = modal.querySelector("gform_confirmation_message");
      if (success) setCookie("newsletterSubscribed", true, 36525); // 100 year cookie
    });
  }

  const scrollY = window.scrollY;
  const bodyHeight = Dom.body.offsetHeight;
  const windowHeight = window.innerHeight;
  const eType = e.type;
  const scrollTrigger = Math.sign(bodyHeight - windowHeight - 2000) === 1 ? 2000 : windowHeight / 2;

  // Check if the modal has not been opened based on 3 event types:
  //   if: the scroll position is at 800px(1) OR the mouse leaves the DOM (2)
  //   else if: on the first call after 10 seconds of time(3)
  if (!hasModalBeenOpened && form) {
    if ((eType === "scroll" && scrollY >= scrollTrigger) || eType === "mouseleave") {
      setModal(modal, "newsletterModalOpened");
    } else if (eType === "DOMContentLoaded") {
      setTimeout(() => {
        if (!getCookie("newsletterModalOpened")) {
          setModal(modal, "newsletterModalOpened");
        }
      }, ms);
    }
  }
};

const handleScroll = (e) => {
  initNewsLetterModal(e);
};
const handleMouseLeave = (e) => {
  initNewsLetterModal(e);
};
!hasModalBeenOpened && window.addEventListener("scroll", handleScroll);
!hasModalBeenOpened && Dom.body.addEventListener("mouseleave", handleMouseLeave);
